/* smx-th-cod.js: copy of pdp-real-cod.js (live 9 Oct 2026) for the MAX seat page template product.seat-max.
   Only additions: config.extraAddons() lines (Seat + ARC bundle) and config.getTotal() for the total line.
   pdp-real-cod.js itself is untouched, so the pillow and other COD pages are unaffected. */
/* COD/Bank Transfer payment-method add-on for the REAL /products/pillow buy-box
   (product.pillow-cod-test template only -- see the "COD box" custom-liquid block in that
   template). Deliberately additive: the existing quantity-tier picker (the 3rd-party
   ".omg-offer" widget) and the native Shopify product-form are left completely alone.

   How it plugs in:
   - The tier widget already keeps the native product-form's hidden `id` (variant) and
     `quantity` inputs in sync with whichever tier the customer has selected, and (crucially)
     the real quantity-break pricing for that variant+quantity is whatever Shopify actually
     applies at checkout -- so we read those two hidden inputs at submit time rather than
     re-implementing tier pricing here.
   - If the customer never touches payment method, the native "Add to cart" button behaves
     exactly as it does today (this script never intercepts that path).
   - If the customer picks Cash on Delivery / Bank Transfer, submitting the form is redirected
     into the same session-based, cart-isolated funnel already built and tested for the
     isolated COD experiment (sessionStorage record -> pages/cod-order-confirmation, which
     calls the existing Cloudflare Worker to create the real order with real Storefront-priced
     totals). No real Shopify cart is ever touched by that path either.

   Now includes the same post-purchase upsell hop as the isolated test funnel: after a
   successful PDP submit, the customer is sent to pages/cod-order-upsell first, and only
   reaches pages/cod-order-confirmation from there (either by accepting or declining the
   upsell) -- see sections/page-cod-upsell.liquid + assets/pdp-cod-pages.js. */
(function () {
  'use strict';

  var PCO_SESSION_KEY = 'pco_session_v1';
  var CONFIRM_PATH = 'pages/cod-order-confirmation';
  // Per-product settings come from window.PCO_REAL_PDP_CONFIG (set in the product
  // template's COD box). Every field is optional; the defaults below are exactly the
  // original pillow behaviour, so the pillow template needs no config changes.
  var DEFAULT_UPSELL_PATH = 'pages/cod-order-upsell';
  var PAYMENT_METHOD_LABELS = { cod: 'Cash on Delivery', bank: 'Bank Transfer' };

  function pcoGenToken() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'pco-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function pcoSaveSession(session) {
    try { sessionStorage.setItem(PCO_SESSION_KEY, JSON.stringify(session)); } catch (e) { /* noop */ }
  }

  function formatThaiPhone(raw) {
    var digits = (raw || '').replace(/\D/g, '');
    if (digits.indexOf('66') === 0 && digits.length > 9) { digits = digits.slice(2); }
    digits = digits.replace(/^0+/, '');
    return digits ? '+66' + digits : '';
  }

  function root() { return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'); }

  function buildPaymentBlockHtml() {
    return ''
      + '<div class="pco-real-payment" id="pco-real-payment">'
      + '  <p class="pco-real-label">เลือกวิธีการชำระเงิน</p>'
      + '  <div class="pco-real-methods">'
      + '    <button type="button" class="pco-real-method-btn" data-method="cod">เก็บเงินปลายทาง</button>'
      + '    <button type="button" class="pco-real-method-btn" data-method="bank">โอนเงินผ่านธนาคาร</button>'
      + '  </div>'
      + '  <div class="pco-real-total" id="pco-real-total" style="display:none;justify-content:space-between;align-items:center;gap:12px;padding:14px 0;margin:16px 0 6px;border-top:1px dashed #d5d5d5;border-bottom:1px dashed #d5d5d5;">'
      + '    <span id="pco-real-total-label" style="font-weight:700;font-size:16px;color:#111;text-align:left;flex:1 1 auto;min-width:0;"></span>'
      + '    <span id="pco-real-total-value" style="white-space:nowrap;text-align:right;flex:0 0 auto;"></span>'
      + '  </div>'
      + '  <div class="pco-real-form" id="pco-real-form" style="display:none;">'
      + '    <div class="pco-real-field"><label for="pco-real-name">ชื่อ-สกุล</label><input type="text" id="pco-real-name" placeholder="ชื่อ-สกุล" autocomplete="name"></div>'
      + '    <div class="pco-real-field"><label for="pco-real-phone">เบอร์โทร</label><div class="pco-real-phone-wrap"><span class="pco-real-phone-flag">🇹🇭 +66</span><input type="tel" id="pco-real-phone" placeholder="8X XXX XXXX" autocomplete="tel" inputmode="numeric"></div></div>'
      + '    <div class="pco-real-field"><label for="pco-real-email">อีเมล</label><input type="email" id="pco-real-email" placeholder="อีเมล" autocomplete="email"></div>'
      + '    <div class="pco-real-field"><label for="pco-real-address">ที่อยู่ (โปรดกรอกให้ครบถ้วน)</label><input type="text" id="pco-real-address" placeholder="ที่อยู่ (บ้านเลขที่ ถนน ตำบล/แขวง)" autocomplete="street-address"></div>'
      + '    <div class="pco-real-field"><label for="pco-real-zip">รหัสไปรษณีย์</label><input type="text" id="pco-real-zip" placeholder="รหัสไปรษณีย์" autocomplete="postal-code" inputmode="numeric"></div>'
      + '  </div>'
      + '  <p class="pco-real-note" id="pco-real-note" style="display:none;"></p>'
      + '  <p class="pco-real-card-link"><a href="javascript:void(0)" id="pco-real-card-link">ต้องการชำระด้วยบัตรเดบิต/เครดิต หรือช่องทางอื่น? คลิกที่นี่</a></p>'
      + '  <p class="pco-real-msg" id="pco-real-msg" hidden></p>'
      + '</div>';
  }

  // Hotlinked from the existing live theme asset -- same icon already used on the reference
  // "2.0" buy button, no need to re-upload it as our own asset.
  var CART_ICON_URL = 'https://ergolab.co/cdn/shop/t/25/assets/pdp-cart-btn-icon.webp';

  // Free "หน้ากากตา" (sleeping/eye mask) gift, 1 per pillow -- see the matching constant
  // and comment in pdp-cod-pages.js. Included here too so a customer who abandons at the
  // upsell step and gets auto-finalized 15 min later (see the Worker's finalizePendingOrders)
  // still gets the correct front-end-only mask quantity on their order.
  var FREE_MASK_VARIANT_ID = '42610235867241';

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function formatBaht(n) {
    return '฿' + Math.round(Number(n) || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Optional front-end cross-sell rows (e.g. the ARC back cushion on the MAX seat page).
  // Rendered by us (not the theme's async "complementary products" block) so the COD
  // order can carry them. Pricing is NOT trusted from here: the Worker prices every
  // non-upsell line through the live Storefront cart, exactly like the main product.
  function buildAddonsHtml(addons) {
    if (!addons || !addons.length) return '';
    var html = '<div class="pco-real-addons" id="pco-real-addons">';
    addons.forEach(function (a, i) {
      var price = Number(a.price) || 0;
      var compare = Number(a.compare) || 0;
      html += '<div class="pco-real-addon" data-index="' + i + '" role="group">'
        + '<label class="pco-real-addon-checkwrap"><input type="checkbox" class="pco-real-addon-check"><span class="pco-real-addon-box" aria-hidden="true"></span></label>'
        + (a.image ? '<img class="pco-real-addon-img" src="' + escapeHtml(a.image) + '" alt="" loading="lazy">' : '')
        + '<span class="pco-real-addon-info">'
        + '<span class="pco-real-addon-title">' + escapeHtml(a.title) + '</span>'
        + (a.subtitle ? '<span class="pco-real-addon-sub">' + escapeHtml(a.subtitle) + '</span>' : '')
        + '<span class="pco-real-addon-price">'
        + (compare > price ? '<s>' + formatBaht(compare) + '</s> ' : '')
        + '<b>' + formatBaht(price) + '</b></span>'
        + '</span>'
        + '<span class="pco-real-addon-qty" aria-label="จำนวน">'
        + '<button type="button" class="pco-real-addon-qbtn pco-real-addon-minus" aria-label="ลดจำนวน">&minus;</button>'
        + '<span class="pco-real-addon-qval">1</span>'
        + '<button type="button" class="pco-real-addon-qbtn pco-real-addon-plus" aria-label="เพิ่มจำนวน">+</button>'
        + '</span>'
        + '</div>';
    });
    return html + '</div>';
  }

  function init() {
    var cfg0 = window.PCO_REAL_PDP_CONFIG || {};
    var boxed = document.querySelector(cfg0.rootSelector || '.product-boxed-section');
    if (!boxed) return; // not on a COD template, nothing to do

    // .qs-mask-banner (the "free eye mask, website customers only" banner) already sits
    // right above .qs-cards in the native markup -- left alone, so it just displays as normal.
    var qsCards = boxed.querySelector('.qs-cards');
    var form = boxed.querySelector('form');
    if (!form) return;
    var submitBtn = form.querySelector('button[type="submit"], button[name="add"]');
    if (!submitBtn) return;

    var config = window.PCO_REAL_PDP_CONFIG || {};
    var defaultLabel = submitBtn.textContent.trim();
    var reserveUrl = config.reserveUrl || '';
    var upsellPath = config.upsellPath || DEFAULT_UPSELL_PATH;
    var giftVariantId = config.giftVariantId || FREE_MASK_VARIANT_ID;
    var giftPerUnit = (config.giftPerUnit === 0 || config.giftPerUnit) ? Number(config.giftPerUnit) : 1;
    var addonsCfg = Array.isArray(config.addons) ? config.addons : [];

    // Replace the theme's default ::after arrow icon on this button with a real cart icon
    // (matching the reference "2.0" buy button), via a dedicated label span so render()
    // can update the text without wiping the icon out each time.
    submitBtn.classList.add('pco-cta-btn');
    var labelSpan = document.createElement('span');
    labelSpan.className = 'pco-cta-label';
    labelSpan.textContent = defaultLabel;
    var iconImg = document.createElement('img');
    iconImg.className = 'pco-cta-icon';
    iconImg.src = CART_ICON_URL;
    iconImg.alt = '';
    iconImg.width = 21;
    iconImg.height = 20;
    // Put our label + icon in front of the theme's own children. The theme's
    // .loading__spinner MUST stay inside the button: product-form.js (the native
    // add-to-cart used by the card/other-payment path) dereferences it on submit, so
    // wiping the button's innerHTML (as this used to do) made that path throw and stall.
    function mountButtonContents() {
      Array.prototype.slice.call(submitBtn.childNodes).forEach(function (n) {
        if (n === labelSpan || n === iconImg) return;
        if (n.nodeType === 3) { submitBtn.removeChild(n); return; }
        if (n.nodeType === 1 && n.tagName === 'SPAN' && !n.classList.contains('loading__spinner') && !n.querySelector('.loading__spinner')) n.style.display = 'none';
      });
      if (labelSpan.parentNode !== submitBtn) submitBtn.insertBefore(labelSpan, submitBtn.firstChild);
      if (iconImg.parentNode !== submitBtn) submitBtn.insertBefore(iconImg, labelSpan.nextSibling);
    }
    mountButtonContents();

    var container = document.createElement('div');
    container.innerHTML = buildAddonsHtml(addonsCfg) + buildPaymentBlockHtml();
    var addonsEl = container.querySelector('#pco-real-addons');
    var block = container.querySelector('#pco-real-payment');
    var anchorCfg = config.anchorSelector ? boxed.querySelector(config.anchorSelector) : null;
    var anchor = anchorCfg || ((qsCards && qsCards.parentElement) ? qsCards : null);
    if (anchor) {
      if (addonsEl) { anchor.parentElement.insertBefore(addonsEl, anchor.nextSibling); anchor = addonsEl; }
      anchor.parentElement.insertBefore(block, anchor.nextSibling);
    } else {
      if (addonsEl) boxed.insertBefore(addonsEl, boxed.firstChild);
      boxed.insertBefore(block, addonsEl ? addonsEl.nextSibling : boxed.firstChild);
    }
    // When we render our own cross-sell rows, the theme's async "complementary
    // products" block (adds to the REAL cart, different widget) must never show --
    // the seat tier script calls jQuery.slideDown() on it after a tier click, so a
    // CSS rule alone is not enough: remove it from the page outright.
    if (addonsCfg.length) {
      Array.prototype.forEach.call(document.querySelectorAll('.product-complementary-section, product-recommendations.complementary-products'), function (el) {
        if (el && el.parentNode) el.parentNode.removeChild(el);
      });
    }
    // Add-on rows: tap anywhere on the row to toggle; the big +/- stepper sets the
    // quantity (and "+" on an unticked row ticks it). State lives here, not in the DOM.
    var addonState = addonsCfg.map(function () { return { checked: false, qty: 1 }; });
    if (addonsEl) {
      Array.prototype.forEach.call(addonsEl.querySelectorAll('.pco-real-addon'), function (row) {
        var i = parseInt(row.getAttribute('data-index'), 10);
        var st = addonState[i];
        var cfg = addonsCfg[i] || {};
        var max = Math.max(1, parseInt(cfg.maxQty, 10) || 4);
        var check = row.querySelector('.pco-real-addon-check');
        var qval = row.querySelector('.pco-real-addon-qval');
        function paint() {
          row.classList.toggle('sel', st.checked);
          check.checked = st.checked;
          qval.textContent = String(st.qty);
          updateTotal();
        }
        row.addEventListener('click', function (e) {
          if (e.target.closest('.pco-real-addon-qty')) return;
          // The label (box + hidden checkbox) toggles natively; ignore the bubbled click so the
          // row handler does not toggle it a second time (which made the box itself look dead).
          if (e.target.closest('.pco-real-addon-checkwrap')) return;
          st.checked = !st.checked;
          paint();
        });
        check.addEventListener('click', function (e) { e.stopPropagation(); st.checked = check.checked; paint(); });
        row.querySelector('.pco-real-addon-minus').addEventListener('click', function (e) {
          e.stopPropagation();
          if (st.qty > 1) st.qty -= 1; else st.checked = false;
          paint();
        });
        row.querySelector('.pco-real-addon-plus').addEventListener('click', function (e) {
          e.stopPropagation();
          // "+" on an unticked row ticks it AND steps the quantity in one tap (Luka, 30 Sep)
          if (!st.checked) st.checked = true;
          if (st.qty < max) st.qty += 1;
          paint();
        });
        paint();
      });
    }
    function selectedAddons() {
      var out = [];
      addonsCfg.forEach(function (a, i) {
        if (!addonState[i] || !addonState[i].checked || !a || !a.variantId) return;
        out.push({
          variantId: String(a.variantId),
          qty: addonState[i].qty,
          productTitle: a.title || '',
          image: a.image || '',
          price: a.price, compare: a.compare
        });
      });
      if (typeof config.extraAddons === 'function') {
        try { (config.extraAddons() || []).forEach(function (a) { if (a && a.variantId && a.qty > 0) out.push(a); }); } catch (e) { /* noop */ }
      }
      return out;
    }

    var methodBtns = Array.prototype.slice.call(block.querySelectorAll('.pco-real-method-btn'));
    var cardLink = block.querySelector('#pco-real-card-link');
    var innerForm = block.querySelector('#pco-real-form');
    var msgEl = block.querySelector('#pco-real-msg');
    var noteEl = block.querySelector('#pco-real-note');
    var chosen = null;

    // Matches the note already shown on the isolated 2.0 test's Bank Transfer option:
    // tells the customer up front (before they submit) that they'll get the bank details
    // and a LINE link for the payment slip right after ordering. No equivalent note for COD.
    var BANK_NOTE_TEXT = 'หลังจากสั่งซื้อ คุณจะได้รับรายละเอียดบัญชีธนาคารและลิงก์ LINE สำหรับส่งสลิปการชำระเงินทันที';

    function updateNote() {
      if (!noteEl) return;
      if (chosen === 'bank') {
        noteEl.textContent = BANK_NOTE_TEXT;
        noteEl.style.display = '';
      } else {
        noteEl.textContent = '';
        noteEl.style.display = 'none';
      }
    }

    function requiredFields() {
      return [
        block.querySelector('#pco-real-name'),
        block.querySelector('#pco-real-phone'),
        block.querySelector('#pco-real-address'),
        block.querySelector('#pco-real-zip')
      ];
    }

    function isCustomMethod() { return chosen === 'cod' || chosen === 'bank'; }

    function valid() {
      if (!isCustomMethod()) return true;
      return requiredFields().every(function (f) { return f && f.value.trim().length > 0; });
    }

    var wantedLabel = '';
    var wantedDisabled = true;

    // The theme's quantity-tier widget rewrites this button's contents (text back to
    // "หยิบใส่ตะกร้า", our icon gone) on load and every time a tier is clicked, which
    // wiped our label. applyButton() restores exactly what render() decided, and the
    // MutationObserver below re-applies it whenever anything else touches the button.
    var applying = false;
    function applyButton() {
      applying = true;
      // If the widget replaced the whole button element, move over to the new one.
      var liveBtn = form.querySelector('button[type="submit"], button[name="add"]');
      if (liveBtn && liveBtn !== submitBtn) {
        submitBtn = liveBtn;
        submitBtn.classList.add('pco-cta-btn');
        observeButton();
      }
      if (labelSpan.parentNode !== submitBtn || iconImg.parentNode !== submitBtn) mountButtonContents();
      if (labelSpan.textContent !== wantedLabel) labelSpan.textContent = wantedLabel;
      submitBtn.classList.toggle('pco-real-disabled', wantedDisabled);
      applying = false;
    }

    // Order total line (7 Oct 2026): shown only once COD or Bank Transfer is picked, so the
    // customer sees what they will pay before confirming. Reads the selected quantity tier
    // card (label, struck price, price) plus any ticked add-ons.
    var totalRow = block.querySelector('#pco-real-total');
    var totalLabel = block.querySelector('#pco-real-total-label');
    var totalValue = block.querySelector('#pco-real-total-value');
    function bahtToNumber(str) { var n = parseFloat(String(str || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; }
    function updateTotal() {
      if (!totalRow) return;
      try {
        if (typeof config.getTotal === 'function') {
          var gt = (chosen === 'cod' || chosen === 'bank') ? config.getTotal() : null;
          if (!gt || !gt.total) { totalRow.style.display = 'none'; return; }
          totalLabel.innerHTML = '<span style="display:block;font-weight:400;font-size:12px;color:#666;margin-bottom:1px;">ยอดรวม</span><span></span>';
          totalLabel.lastChild.textContent = gt.label || '';
          totalValue.innerHTML = (gt.compare > gt.total ? '<s style="color:#888;font-size:14px;font-weight:400;margin-right:8px;">' + formatBaht(gt.compare) + '</s>' : '')
            + '<b style="color:#1A256C;font-size:20px;font-weight:800;">' + formatBaht(gt.total) + '</b>';
          totalRow.style.display = 'flex';
          return;
        }
        var card = (chosen === 'cod' || chosen === 'bank') ? document.querySelector('.qs-cards .qs-card.sel') : null;
        var priceEl = card && card.querySelector('.qs-price');
        var total = priceEl ? bahtToNumber(priceEl.textContent) : 0;
        if (!card || !total) { totalRow.style.display = 'none'; return; }
        var strikeEl = card.querySelector('.qs-strike');
        var compare = strikeEl ? bahtToNumber(strikeEl.textContent) : 0;
        if (compare < total) compare = total;
        var qtyEl = card.querySelector('.qs-qty');
        var qtyText = qtyEl ? qtyEl.textContent.replace(/\s+/g, ' ').trim() : '';
        // Label: small "ยอดรวม" caption, then "<product name> - 2x" (falls back to the tier text).
        var nameEl = document.querySelector('.hero_heading') || document.querySelector('h1');
        var prodName = String(config.productTitle || (nameEl ? nameEl.textContent : '') || '').replace(/\s+/g, ' ').trim().replace(/\s+\d+\.\d+$/, '');
        var qtyNum = parseInt(card.getAttribute('data-qty'), 10) || parseInt((qtyText.match(/\d+/) || [])[0], 10) || 0;
        var unitM = qtyText.match(/\d+\s*(\S+)\s*$/);
        var detail = (prodName && qtyNum) ? (prodName + ' - ' + qtyNum + (unitM ? ' ' + unitM[1] : 'x')) : qtyText;
        // With add-ons ticked: "2 เบาะรองนั่ง + 2 เบาะรองหลัง" (Thai product words only).
        function thaiShort(t) { return String(t || '').replace(/[A-Za-z0-9().\-]+/g, ' ').replace(/\s+/g, ' ').trim(); }
        var mainShort = thaiShort(config.productTitle || (nameEl ? nameEl.textContent : ''));
        var addonParts = [];
        selectedAddons().forEach(function (a) {
          var q = a.qty || 1, pr = Number(a.price) || 0, cp = Number(a.compare) || 0;
          total += pr * q; compare += (cp > pr ? cp : pr) * q;
          addonParts.push(q + ' ' + (thaiShort(a.productTitle) || 'สินค้าเพิ่ม'));
        });
        if (addonParts.length && qtyNum && mainShort) detail = qtyNum + ' ' + mainShort + ' + ' + addonParts.join(' + ');
        else if (addonParts.length) detail += ' + ' + addonParts.join(' + ');
        totalLabel.innerHTML = '<span style="display:block;font-weight:400;font-size:12px;color:#666;margin-bottom:1px;">ยอดรวม</span><span></span>';
        totalLabel.lastChild.textContent = detail;
        totalValue.innerHTML = (compare > total ? '<s style="color:#888;font-size:14px;font-weight:400;margin-right:8px;">' + formatBaht(compare) + '</s>' : '')
          + '<b style="color:#1A256C;font-size:20px;font-weight:800;">' + formatBaht(total) + '</b>';
        totalRow.style.display = 'flex';
      } catch (e) { totalRow.style.display = 'none'; }
    }
    if (addonsEl) addonsEl.addEventListener('click', function () { setTimeout(updateTotal, 0); });

    function render() {
      updateTotal();
      if (!chosen) {
        wantedLabel = 'เลือกวิธีการชำระเงิน';
        wantedDisabled = true;
      } else if (chosen === 'card') {
        wantedLabel = defaultLabel;
        wantedDisabled = false;
      } else {
        wantedLabel = 'ยืนยันการสั่งซื้อ';
        wantedDisabled = !valid();
      }
      applyButton();
    }

    var btnObserver = null;
    function observeButton() {
      if (!window.MutationObserver) return;
      if (btnObserver) btnObserver.disconnect();
      btnObserver = new MutationObserver(function () {
        if (applying) return;
        if (labelSpan.parentNode !== submitBtn || labelSpan.textContent !== wantedLabel
          || submitBtn.classList.contains('pco-real-disabled') !== wantedDisabled) {
          applyButton();
        }
      });
      btnObserver.observe(submitBtn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    observeButton();
    // Also watch the form itself in case the button element gets swapped out entirely.
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (applying) return;
        var liveBtn = form.querySelector('button[type="submit"], button[name="add"]');
        if (liveBtn && liveBtn !== submitBtn) applyButton();
      }).observe(form, { childList: true, subtree: true });
    }
    // Belt and braces for scripts that swap the whole button rather than editing it.
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.omg-option-item, .qs-card, .qs-cards, .x-swatch-card, .x-qtyBtn')) setTimeout(render, 0);
    }, true);
    document.addEventListener('smx:change', function () { render(); });

    methodBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        methodBtns.forEach(function (x) { x.classList.remove('sel'); });
        b.classList.add('sel');
        chosen = b.getAttribute('data-method');
        if (innerForm) innerForm.style.display = '';
        updateNote();
        render();
      });
    });

    if (cardLink) {
      cardLink.addEventListener('click', function () {
        methodBtns.forEach(function (x) { x.classList.remove('sel'); });
        chosen = 'card';
        if (innerForm) innerForm.style.display = 'none';
        updateNote();
        render();
      });
    }

    requiredFields().forEach(function (f) { if (f) f.addEventListener('input', render); });

    render();

    function reserveOrder(session, variantId, quantity, attrs) {
      if (!reserveUrl) return;
      try {
        // Same line list the confirm page would send if the customer declined the
        // upsell: base, any checked add-ons, then the free gift (1 per base unit).
        var lines = [{ variantId: variantId, quantity: quantity, role: 'base' }];
        (session.addons || []).forEach(function (a) {
          lines.push({ variantId: a.variantId, quantity: a.qty, role: 'addon' });
        });
        var giftQty = quantity * giftPerUnit;
        if (giftQty > 0) lines.push({ variantId: giftVariantId, quantity: giftQty, role: 'gift' });
        fetch(reserveUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          body: JSON.stringify({
            cartToken: session.token,
            lineItems: lines,
            customer: session.customer,
            cartAttributes: attrs
          })
        }).catch(function () { /* best-effort */ });
      } catch (e) { /* noop */ }
    }

    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!isCustomMethod()) return; // card / no selection: leave the native add-to-cart handler untouched
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!valid()) return;

      var paymentMethod = PAYMENT_METHOD_LABELS[chosen] || PAYMENT_METHOD_LABELS.cod;
      var name = block.querySelector('#pco-real-name').value.trim();
      var phone = formatThaiPhone(block.querySelector('#pco-real-phone').value.trim());
      var email = block.querySelector('#pco-real-email').value.trim();
      // Email is optional. A malformed one must never block or lose the order, so if it
      // doesn't look like an address, just don't send it (Shopify would reject the order).
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) email = '';
      var address = block.querySelector('#pco-real-address').value.trim();
      var zip = block.querySelector('#pco-real-zip').value.trim();

      var fd = new FormData(form);
      var variantId = fd.get('id');
      var quantity = parseInt(fd.get('quantity'), 10) || 1;

      submitBtn.classList.add('pco-real-disabled');

      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return {}; })
        .then(function (cart) {
          var session = {
            token: pcoGenToken(),
            variantId: variantId,
            quantity: quantity,
            productTitle: config.productTitle || '',
            price: '',
            comparePrice: '',
            image: config.productImage || '',
            paymentMethod: paymentMethod,
            customer: { fullName: name, phone: phone, email: email, address: address, zip: zip },
            cartAttributes: (cart && cart.attributes) || {},
            addons: selectedAddons(),
            gift: { variantId: giftVariantId, perUnit: giftPerUnit },
            upsell: null
          };
          // Upsell-page split test (4 Oct 2026): A = red decline link + "adds ฿X" line,
          // B = red decline link only. Stamped on the order as custom attribute upsell_variant
          // (both the reserve call and the confirm page copy session.cartAttributes).
          session.upsellVariant = (Math.random() < 0.5) ? 'A' : 'B';
          session.cartAttributes.upsell_variant = session.upsellVariant;
          // Bank-transfer upsell test (5 Oct 2026): bank customers who see the upsell mostly do not
          // pay, so 50% of bank orders skip the upsell pages and go straight to the confirmation
          // page. Stamped on the order as custom attribute bank_upsell = skip | show.
          session.bankUpsell = '';
          // 9 Oct 2026 21:2x: COD upsell switched back ON (Thailand Post data 5-7 Oct: upsell takers
          // refuse more but collect ~20% more per order). Bank transfer still always skips the upsell.
          if (chosen === 'bank') {
            session.bankUpsell = 'skip'; // 6 Oct 2026: test ended, bank transfer always skips the upsell (?bu=show still previews it)
            var buForce = (window.location.search.match(/[?&]bu=(skip|show)\b/) || [])[1]; // preview/testing switch
            if (buForce) session.bankUpsell = buForce;
            session.cartAttributes.bank_upsell = session.bankUpsell;
            if (session.bankUpsell === 'skip') { session.upsellVariant = ''; delete session.cartAttributes.upsell_variant; }
          }
          // 19 Oct 2026: page-level extra attributes (e.g. cod_source: 'seat-listicle' on the seat
          // listicle buy box). The worker turns cod_source into an order tag. Not set on the seat page.
          var extra = config.extraAttributes || {};
          Object.keys(extra).forEach(function (k) { session.cartAttributes[k] = extra[k]; });
          pcoSaveSession(session);

          var reserveAttrs = {};
          Object.keys(session.cartAttributes).forEach(function (k) { reserveAttrs[k] = session.cartAttributes[k]; });
          reserveAttrs['Payment Method'] = paymentMethod;
          reserveAttrs['Full Name'] = name;
          reserveAttrs['Phone'] = phone;
          reserveAttrs['Email'] = email;
          reserveAttrs['Full Address'] = address;
          reserveAttrs['Zip Code'] = zip;
          reserveOrder(session, variantId, quantity, reserveAttrs);

          window.location.href = root() + (session.bankUpsell === 'skip' ? 'pages/cod-order-confirmation' : upsellPath);
        })
        .catch(function (err) {
          submitBtn.classList.remove('pco-real-disabled');
          if (msgEl) { msgEl.textContent = (err && err.message) || 'Something went wrong'; msgEl.hidden = false; }
        });
    }, true);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
